import axios from "axios";
import { config } from "../config";

export const DrupalService = {
  getToken: async () => {
    try {
      const result = await axios.get(config.API_DOMAIN + '/session/token');

      if (result && result.status === 200) {
        return result.data;
      }
    } catch (exp) {
      console.log(exp);
      return null;
    }

  },
}
